import type { WorkspaceConfigRequest } from "@/services/api/workspace-config/types";

/** Default: glass / transparent window chrome */
export const DEFAULT_WINDOW_TRANSPARENCY = true;

/**
 * Resolves window transparency from API/local config, including legacy `opaqueWindows`.
 * `true` = transparency on (glass); `false` = solid windows.
 */
export function resolveWindowTransparency(
  apiConfig: WorkspaceConfigRequest,
  localConfig: WorkspaceConfigRequest | null | undefined,
): boolean {
  if (apiConfig.windowTransparency !== undefined) {
    return apiConfig.windowTransparency;
  }
  if (localConfig?.windowTransparency !== undefined) {
    return localConfig.windowTransparency;
  }
  if (apiConfig.opaqueWindows !== undefined) {
    return !apiConfig.opaqueWindows;
  }
  if (localConfig?.opaqueWindows !== undefined) {
    return !localConfig.opaqueWindows;
  }
  return DEFAULT_WINDOW_TRANSPARENCY;
}
